export const sortRewardsByPoints = function (userRewards: Array<any>) {
    return userRewards.sort((a, b) =>
        a.points! > b.points! ? 1 : -1
    )
}

export const removeDuplicates = function (arr: Array<any>) {
    const uniqueValues: any = [];
    const filteredArray = arr.filter(mark => {
        const duplicate = uniqueValues.includes(mark.points);
        if(!duplicate){
            uniqueValues.push(mark.points)
            return true
        }
        return false
    })
    return filteredArray;
}

export const sortRewardsByRank =  function(benefitsList: Array<any>) {
    return benefitsList?.sort((a, b) =>
        a.rank! > b.rank!
            ? 1
            : a.rank === b.rank
            ? a.title > b.title
                ? 1
                : -1
            : -1
    )
}